import { render, staticRenderFns } from "./session-professional-area.vue?vue&type=template&id=05312b64"
import script from "./session-professional-area.vue?vue&type=script&lang=ts"
export * from "./session-professional-area.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports